import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Horse_show } from '../models/horse_show';
import { Signature } from '../models/signature';
import { Horse_show_entry_with_types } from '../models/horse_show_entry_with_types';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class CopyEntryForCircuitService {

  constructor(private http: HttpClient) { }

  public getEntryToCopy(id: string): Promise<Horse_show_entry_with_types> {
      return new Promise((resolve, reject) => {
        return this.http.get(AppSettings.API_ENDPOINT + 'new_horse_show_entry_for_circuit/id/' + id).subscribe((response:any) => {
          if(response.type == 'horse_show_entry_with_types' && response.data){
            resolve(response.data);
          } else {
            reject(response);
          }

        },
          error_response => {
                if(error_response instanceof HttpErrorResponse){
                  reject(error_response.error);
                }
                reject(error_response);
          });
      });
  }

  copyForCircuit(horse_shows: Horse_show[], horse_show_entry:Horse_show_entry_with_types): Promise<any> {

    let post_data = {
        data: {
          type: 'horse_show_entry_circuit_copy_request',
          attributes: {
            horse_shows: horse_shows,
            horse_show_entry: horse_show_entry,
            }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'copy_horse_show_entry_for_circuit',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='horse_show_entry_circuit_copy_response') {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : JSON.stringify(error));
                  }
                });
            });

  }


}
